/** Graduated-rate schedule helpers shared by the income-tax brackets and the Pub 15-T tables. */

/** Round to cents (half away from zero for positive amounts, which is all we produce). */
export function cents(x: number): number {
  return Math.round((x + Number.EPSILON * Math.sign(x)) * 100) / 100;
}

export interface ScheduleResult {
  tax: number;
  /** Rate of the band that `amount` falls in (0 when amount <= 0). */
  marginalRate: number;
}

/**
 * Tax on `amount` under a schedule with `tops` (upper bound of each band) and `rates`
 * (one more than tops; the last applies above the last top). Mirrors FUN_1000c8c0.
 */
export function scheduleTax(tops: number[], rates: number[], amount: number): ScheduleResult {
  if (amount <= 0) return { tax: 0, marginalRate: 0 };
  let tax = 0;
  let lower = 0;
  for (let i = 0; i < tops.length; i++) {
    const top = tops[i];
    if (amount <= top) {
      tax += (amount - lower) * rates[i];
      return { tax: cents(tax), marginalRate: rates[i] };
    }
    tax += (top - lower) * rates[i];
    lower = top;
  }
  tax += (amount - lower) * rates[tops.length];
  return { tax: cents(tax), marginalRate: rates[tops.length] };
}

export const clamp0 = (x: number): number => (x > 0 ? x : 0);
export const min = Math.min;
export const max = Math.max;
